"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _ArrayHelper = require("./ArrayHelper");

var _cssConstants = _interopRequireDefault(require("../../targets/cord_eurofh_teams/cssConstants.js"));

var _instance = null;

var ScreenHelper = /*#__PURE__*/function () {
  (0, _createClass2["default"])(ScreenHelper, null, [{
    key: "instance",

    /**
     *
     * @returns {ScreenHelper}
     */
    value: function instance() {
      if (!_instance) {
        _instance = new ScreenHelper();
      }

      return _instance;
    }
  }]);

  function ScreenHelper() {
    var _this = this;

    (0, _classCallCheck2["default"])(this, ScreenHelper);
    (0, _defineProperty2["default"])(this, "onWindowResize", function () {
      console.log('window resized');

      _this.onWindowSizeChangedListeners.forEach(function (listener) {
        return listener();
      });
    });
    (0, _defineProperty2["default"])(this, "onWidescreenMediaQueryChanged", function () {
      _this.isWidescreen = _this.mqlWidescreen.matches;

      _this.onWidescreenChangedListeners.forEach(function (listener) {
        return listener(_this.isWidescreen);
      });
    });

    if (!window) {
      throw new Error('cannot call constructor on ScreenHelper if window is not defined!');
    }

    window.addEventListener('resize', this.onWindowResize);
    this.mqlWidescreen = window.matchMedia("(min-width: ".concat(_cssConstants["default"].thresholdScreenWidth, ")"));
    this.mqlWidescreen.addListener(this.onWidescreenMediaQueryChanged);
    this.isWidescreen = this.mqlWidescreen.matches;
    this.onWindowSizeChangedListeners = [];
    this.onWidescreenChangedListeners = [];
  }
  /**
   * This method should be called if you ever think of replacing `instance` variable
   */


  (0, _createClass2["default"])(ScreenHelper, [{
    key: "unload",
    value: function unload() {
      this.mqlWidescreen.removeListener(this.onWidescreenMediaQueryChanged);
    }
  }, {
    key: "addOnWidescreenChangedListener",
    value: function addOnWidescreenChangedListener(listener) {
      this.onWidescreenChangedListeners.push(listener);
    }
  }, {
    key: "addOnWindowSizeChangedListener",
    value: function addOnWindowSizeChangedListener(listener) {
      this.onWindowSizeChangedListeners.push(listener);
    }
  }, {
    key: "removeOnWideScreenChangedListener",
    value: function removeOnWideScreenChangedListener(listener) {
      (0, _ArrayHelper.removeElement)(this.onWidescreenChangedListeners, listener);
    }
  }, {
    key: "removeOnWindowSizeChangedListener",
    value: function removeOnWindowSizeChangedListener(listener) {
      (0, _ArrayHelper.removeElement)(this.onWindowSizeChangedListeners, listener);
    }
  }]);
  return ScreenHelper;
}();

var _default = ScreenHelper;
exports["default"] = _default;